import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { simpleDateTime, getStatusColor, STATUS_LABEL_MAP } from '../../utils/WorkOrder';
import type { WorkOrder } from 'integrations-vantify-client-services';
import styles from './RequestCard.scss';
import { Pill } from '../Pill/Pill';
import { M, S } from 'design-system-web';

export function RequestCard({
  interaction,
  isActive,
}: {
  interaction: WorkOrder;
  isActive: boolean;
}) {
  const { t } = useTranslation();

  const statusColor = getStatusColor(interaction.status);

  return (
    <div className={cx(styles.container, isActive ? styles.isActive : '')}>
      <div className={cx(styles.section, styles.borderRadiusTop)}>
        <div className={styles.row}>
          <S style={{ color: 'black' }}>
            {simpleDateTime(interaction.createdAt)}
          </S>
            <Pill
              text={STATUS_LABEL_MAP[interaction.status] ?? interaction.status ?? ''}
              size="medium"
              className={styles.pill}
              color={statusColor}
              iconName="circle"
              iconColor={statusColor}
            />
        </div>
        <div >
          <S style={{ color: 'black' }}>
            {t('shared.integrations.vantify.workorder.request')}
            {interaction.id}
          </S>
        </div>
        <div className={styles.description}>
          <M>{interaction.summary}</M>
        </div>
      </div>
    </div>
  );
}